import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube, Linkedin } from 'lucide-react'; // Added social icons
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useLanguage();

  const quickLinks = [
    { key: 'nav_programme', href: '#programme', link: '/programme' },
    { key: 'nav_services', href: '#services', link: '/services' },
    { key: 'nav_facilities', href: '#facilities', link: '/facilities' },
    { key: 'nav_doctors', href: '#doctors', link: '/expert' },
    { key: 'nav_procedures', href: '#procedures', link: '/procedures' },
    { key: 'nav_contact', href: '#contact', link: '/contact' },
  ];

  // Added Social Media Data
  const socialLinks = [
    { icon: Facebook, href: 'https://www.facebook.com/profile.php?id=100066652312267', label: 'Facebook' },
    { icon: Instagram, href: 'https://www.instagram.com/gastrocare.in/', label: 'Instagram' },
    { icon: Youtube, href: 'https://www.youtube.com/@drsanjaykumargastrocare', label: 'Youtube' },
    // { icon: Linkedin, href: 'https://linkedin.com', label: 'Linkedin' },
  ];

  // function to scroll to top of the page when a quick link is clicked
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8" data-testid="footer">
      <div className="section-container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12 p-2">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-[#800000] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">GC</span>
              </div>
              <div>
                <p className="font-bold text-white text-lg leading-tight">GastroCare</p>
                <p className="text-xs text-slate-400">Obesity Cure</p>
              </div>
            </div>
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed">
              {t('footer_tagline')}
            </p>

            {/* Social Media Icons Section */}
            <div className="flex items-center gap-4 mb-6 mt-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-slate-800 rounded-full hover:bg-[#800000] transition-colors duration-300"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5 text-white" />
                </a>
              ))}
            </div>

            {/* <div className="flex items-center gap-4">
              <a
                href="https://www.gastrocare.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#800000] hover:text-[#a00000] font-medium"
                data-testid="footer-website-link"
              >
                www.gastrocare.in
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          {/* <div>
            <h4 className="font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((item) => (
                <li key={item.key}>
                  <Link
                    to={item.link}
                   //  to={`/${item.href}`}
                    className="text-slate-400 hover:text-[#800000] transition-colors text-sm"
                    data-testid={`nav-${item.key}`}
                    onClick={(e) => scrollToSection(e, item.href)}
                  >
                    {t(item.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-white mb-4">Contact Us</h4>
          <div className='py-2'>
              <ul className="space-y-3">
             
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#800000] flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="tel:+917554055123" className="text-slate-400 hover:text-[#800000] text-sm">
                    {t('contact_phone1')}
                  </a>
                  <a href="tel:+919300951215" className="text-slate-400 hover:text-[#800000] text-sm">
                    +91 93009 51215
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#800000] flex-shrink-0" />
                <a href="mailto:contact@bigbariatrics.com" className="text-slate-400 hover:text-[#800000] text-sm">
                  contact@bigbariatrics.com
                </a>
              </li>
               <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#800000] flex-shrink-0 mt-0.5" />
                {/* <span className="text-slate-400 text-sm">{t('contact_address')}</span> */}
               <span className="text-slate-400 text-sm"> 120-121, Main Rd No. 3, near Personal Branch SBI, E-3, Arera Colony, Bhopal, Madhya Pradesh 462016</span>  
              </li>
            </ul>
          </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} GastroCare Bhopal. {t('footer_rights')}
            </p>
            <p className="text-slate-500 text-xs text-center md:text-right max-w-lg">
              {/* {t('footer_disclaimer')} */}
            </p>
          </div>
        </div>
      </div>

      {/* Developed By Section */}
      <div className="flex justify-center text-slate-500 text-xs text-center mt-8">
        <p>
          Developed by 
          <span>
            <a href="https://mistpl.com/" target='_blank' rel="noopener noreferrer" className='text-[#800000] hover:underline ml-1'>
              MISTPL
            </a>
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;